
import  {default as Images}  from "./images";

export default Images;